import React, { createContext, useContext, FC } from 'react';
import { MaterialCommodity, Weld, CommodityType } from '@bechtel/types';

type Commodity = MaterialCommodity | Weld;

interface CommodityContextProps {
  id: Commodity['id'];
  tag: Commodity['tag'];
  typeId: CommodityType['id'];
  typeName: CommodityType['name'];
}

const CommodityContextPrivate = createContext<CommodityContextProps>({
  id: '',
  tag: '',
  typeId: '',
  typeName: '',
});

const { Provider } = CommodityContextPrivate;

export const useCommodity = () => {
  return useContext(CommodityContextPrivate);
};

export const CommodityContext: FC<CommodityContextProps> = ({ children, ...commodityProps }) => {
  return <Provider value={commodityProps}>{children}</Provider>;
};
